import type { Settings, SystemStatus } from './api'

const BASE = ''

export async function getConfig(): Promise<Settings> {
  const r = await fetch(`${BASE}/api/config`)
  return r.json()
}

export async function saveConfig(data: Settings): Promise<void> {
  await fetch(`${BASE}/api/config`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(data),
  })
}

export async function getStatus(): Promise<SystemStatus> {
  const r = await fetch(`${BASE}/api/status`)
  return r.json()
}

export async function startWorkers(): Promise<{ status?: string; error?: string }> {
  const r = await fetch(`${BASE}/api/start`, { method: 'POST' })
  return r.json()
}

export async function stopWorkers(): Promise<{ status?: string; error?: string }> {
  const r = await fetch(`${BASE}/api/stop`, { method: 'POST' })
  return r.json()
}

export interface RemoteSettingsResult {
  ok: boolean
  id?: string
  raw?: Record<string, any>
  mapped?: Record<string, any>
  error?: string
  raw_preview?: string
}

// Серверный прокси: получить удалённые настройки прокачки по идентификатору
// удалённой работы (ID_SERVER_REMOTE). GET идёт со стороны панели.
export async function getProfilerRemoteSettings(id: string): Promise<RemoteSettingsResult> {
  try {
    const r = await fetch(
      `${BASE}/api/profiler/remote-settings?id=${encodeURIComponent(id)}`,
      { signal: AbortSignal.timeout(25000) },
    )
    const data = await r.json().catch(() => ({}))
    if (!r.ok && data && data.ok === undefined) {
      return { ok: false, error: data.error || `Ошибка сервера (${r.status})` }
    }
    return data as RemoteSettingsResult
  } catch (e: any) {
    return { ok: false, error: e?.name === 'TimeoutError' ? 'Превышено время ожидания' : 'Сеть недоступна' }
  }
}
